@if (form | inputIsActive: config) {
  <input type="color" [value]="value" (change)="inputFieldChanged($event); $event.stopPropagation()" />
}
